import { JogId } from ".";

export const JogIdConversionMap = new Map<string, JogId>([  
  // Obsolete WSP filters
  ["0", JogId.Other],
  ["1", JogId.SeattleArea],
  ["2", JogId.KingCountyNortheast],
  ["3", JogId.KingCountySouth],
  ["4", JogId.Tacoma],
  ["5", JogId.JBLM],
  ["6", JogId.SnohomishCounty],
  ["7", JogId.KitsapPeninsula],
  ["8", JogId.ClarkCounty],
]);

const AllJogIds = [
  JogId.SeattleArea,  
  JogId.KingCountyNortheast,
  JogId.KingCountySouth,
  JogId.Tacoma,
  JogId.JBLM,
  JogId.SnohomishCounty,
  JogId.KitsapPeninsula,
  JogId.ClarkCounty,
  JogId.LowerColumbiaRiver,
  JogId.NorthwestWashington,
  JogId.EasternWashington,
];

export const sanitizeJogIds = (jogIds: string): string => {
  let jogIdSet = new Set(jogIds.split(","));
  if (jogIdSet.has(JogId.Wsp)) {
    
    // Remove the "WSP" JogId that's not a real JogId, so it's not sent in the API request
    jogIdSet.delete(JogId.Wsp);

    // Add all JogIds to retrieve WSP events and any incidents for all WSP districts. (the Set will avoid duplicating any IDs)    
    AllJogIds.forEach(value => jogIdSet.add(value));
    
    return [...jogIdSet.values()].join(",");
  }  else {
    return jogIds;
  }  
}